import React, { Component } from 'react'
import { getCourseId } from '../../helpers/course'
import {
  getAttributeCourseStaticInfo,
  getEnrolledUnits,
  isUpdatingUnitLocation,
  getDualInsanceBlockModelCalendarTypes,
  getCourseStudentStudyPackageNumber,
  willDoubleUpUnits,
  willOverlapUnits,
  alreadyEnrolledUnit,
  willExceed48CreditPoints,
  getCalendarTypeName
} from '../../helpers/enrolment'
import { removeUnit, updateEnrolment } from '../../services/vu'
import EditUnitModal from '../tags/Modals/EditUnitModal'
import UnitTable from '../tags/UnitTable'

import { Redirect, Route, Switch } from 'react-router-dom'
import UnitStage from '../../enums/UnitStage'
import UnitStatus from '../../enums/UnitStatus'
import { getConfiguration } from '../../helpers/configuration'
import DrupalModal from './Modals/DrupalModal'
import { CustomModal } from './Modals/Modal'
import ErrorModal from './Modals/ErrorModal'
import SuggestedUnitsModal from '../tags/Modals/SuggestedUnitsModal'
import { processUnitAddErrors } from '../../helpers/errors'
import BlockType from '../../enums/BlockType'

class EnrolmentContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      studentId: '',

      showModal: false,
      modalUnit: '',
      editing: false,

      addUnitCalloutModalOpen: false,
      redirectToSearch: false,
      addUnitModalCalendarType: '',
      addUnitModalYear: '',

      showAdvancedStandingModal: false,
      showWithdrawalConfirmationModal: false,
      withdrawSubmissionConfirmation: false,
      unitToBeWithdrawn: null,
      showWithdrawModal: false,

      openSuggestionUnitsModel: false,
      openEnrolmentErrorModel: false
    }
  }

  componentDidMount() {

  }

  enrolmentUpdating = (loadingUnit = false) => {
    if (this.props.hasOwnProperty('onEnrolmentUpdating')) {
      this.props.onEnrolmentUpdating(loadingUnit)
    }
  }

  enrolmentUpdated = () => {
    this.setState({
      showLastUnitWithdrawMessage: false
    })
    if (this.props.hasOwnProperty('onEnrolmentUpdated')) {
      this.props.onEnrolmentUpdated()
    }
  }

  handleCloseModal = () => {
    this.setState({
      showModal: false,
      editing: false
    })
  }
  handleNoEnrolmentModal = () => {
    this.setState({
      showWithdrawModal: false
    })
  }

  handleAddUnit = (calendarType, year, callout = false, redirectToSearch = false) => {
    this.setState({
      redirectToSearch: redirectToSearch,
      addUnitCalloutModalOpen: callout,
      addUnitModalCalendarType: calendarType,
      addUnitModalYear: year,
      openSuggestionUnitsModel: !callout
    })
  }

  handleAddUnitCallout = () => {
    this.handleAddUnit('', this.props.enrolYear, true, true)
  }

  handleEditUnit = (unitCd, studyPeriod, availabilityYear) => {
    this.setState({
      modalUnit: unitCd,
      modalStudyPeriod: studyPeriod,
      modalAvailabilityYear: availabilityYear,
      showModal: true
    })
  }

  /**
   * Get all the enrolled units that have not been discontinued.
   *
   * @return {Array}
   */
  getActiveEnrolledUnits = () =>
    this.props.enrolledUnits.filter(
      unit =>
        (unit.unitStatus === UnitStatus.PLANNED && unit.unitStage === UnitStage.PLANNED) ||
        (unit.unitStatus === UnitStatus.ENROLLED && unit.unitStage === UnitStage.ENROLLED) ||
        (unit.unitStatus === UnitStatus.PASS && unit.unitStage === UnitStage.COMPLETED)(unit.unitStatus === UnitStatus.FAIL && unit.unitStage === UnitStage.COMPLETED)
    )

  getMutableUnits = () =>
    this.getActiveEnrolledUnits().filter(
      unit => (unit.unitStatus === UnitStatus.PLANNED && unit.unitStage === UnitStage.PLANNED) || (unit.unitStatus === UnitStatus.ENROLLED && unit.unitStage === UnitStage.ENROLLED)
    )

  //TODO no edit unit only for planned units change this

  updateUnit = (oldUnit, updatedUnit) => {
    if (isUpdatingUnitLocation(oldUnit, updatedUnit)) {
      return this.updateUnitLocation(updatedUnit)
    }

    return this.updateUnitCalendarType(oldUnit, updatedUnit)
  }
  //Changing the funtion to use updated unit class instead of old unit class
  updateUnitLocation = updatedUnit => {
    return updateEnrolment(
      this.getEnrolmentPayload({
        ...updatedUnit,
        action: 'MODIFY'
      })
    )
  }

  updateUnitCalendarType = (oldUnit, updatedUnit) => {
    return this.removeUnit(oldUnit).then(this.handleResponse(responses => this.addUnit(updatedUnit)))
  }

  handleResponse = callback => (responses = []) => {
    if (responses.length > 0) {
      const response = responses[0]
      if (response.unitResponse && response.unitResponse.status === 'SUCCESSFUL') {
        return callback(responses)
      }
    }
    throw responses
  }

  dispatchError = errorText => {
    alert(errorText)
    this.cleanUpEditModal()
  }

  cleanUpEditModal = () => {
    this.handleCloseModal()
    this.enrolmentUpdated()
  }

  getEnrolmentPayload = unit => ({
    personId: this.state.studentId,
    courseId: getCourseId(),
    unitSet: [
      {
        unit: unit
      }
    ]
  })

  reinstateAndModifyDiscontinuedUnit = (updatedUnit, previouslyEnrolledUnit) => {
    return this.reinstateDiscontinuedUnit(updatedUnit, previouslyEnrolledUnit).then(
      this.handleResponse(() => {
        const unitToModify = {
          ...updatedUnit,
          action: 'MODIFY',
          attemptStatus: 'UNCONFIRM'
        }

        return updateEnrolment(this.getEnrolmentPayload(unitToModify))
      })
    )
  }

  reinstateDiscontinuedUnit = (updatedUnit, previouslyEnrolledUnit) => {
    if (previouslyEnrolledUnit.locationCd !== updatedUnit.locationCd) {
      return updateEnrolment(
        this.getEnrolmentPayload({
          ...previouslyEnrolledUnit,
          action: 'RE-INSTATE',
          attemptStatus: 'UNCONFIRM',
          unitClass: updatedUnit.unitClass
        })
      )
    }

    return updateEnrolment(
      this.getEnrolmentPayload({
        ...updatedUnit,
        action: 'RE-INSTATE',
        attemptStatus: 'UNCONFIRM',
        unitClass: previouslyEnrolledUnit.unitClass
      })
    )
  }

  confirmUnit = unitToAdd => {
    return getEnrolledUnits().then(({ unitSet = [] }) => {
      const unit = unitSet.find(unit => {
        return unit.unitCd === unitToAdd.unitCd && unit.calendarType === unitToAdd.calendarType && unit.supAlternateCd === unitToAdd.supAlternateCd
      })
      const unitToModify = {
        ...unitToAdd,
        action: 'MODIFY',
        unitClass: unit.unitClass
      }

      return updateEnrolment(this.getEnrolmentPayload(unitToModify))
    })
  }

  getPreviouslyEnrolledUnit = (unitSet = [], calendarType, year, unitCode) => {
    return unitSet.find(enrolledUnit => {
      return (
        enrolledUnit.attemptStatus === 'DISCONTIN' &&
        enrolledUnit.unitCd === unitCode &&
        // enrolledUnit.locationCd === payload.locationCd &&
        enrolledUnit.calendarType === calendarType &&
        enrolledUnit.supAlternateCd === year
      )
    })
  }

  getUnconfirmedUnit = (unitSet = [], calendarType, year, unitCode) => {
    return unitSet.find(enrolledUnit => {
      return (
        enrolledUnit.attemptStatus === 'UNCONFIRM' &&
        enrolledUnit.unitCd === unitCode &&
        // enrolledUnit.locationCd === payload.locationCd &&
        enrolledUnit.calendarType === calendarType &&
        enrolledUnit.supAlternateCd === year
      )
    })
  }

  addUnit = payload => {
    return this.enrolIntoUnit(payload, this.state.modalUnit)
  }

  enrolIntoUnit = (payload, unitCode) => {
    return getEnrolledUnits().then(({ unitSet = [] }) => {
      const previouslyEnrolledUnit = this.getPreviouslyEnrolledUnit(unitSet, payload.calendarType, payload.supAlternateCd, unitCode)

      if (previouslyEnrolledUnit) {
        return this.reinstateAndModifyDiscontinuedUnit(payload, previouslyEnrolledUnit)
      } else {
        const unconfirmedUnit = this.getUnconfirmedUnit(unitSet, payload.calendarType, payload.supAlternateCd, unitCode)

        const unitToAdd = {
          ...payload,
          action: 'ADD'
        }

        if (unconfirmedUnit) {
          return this.confirmUnit(unitToAdd)
        } else {
          return updateEnrolment(this.getEnrolmentPayload(unitToAdd)).then(
            this.handleResponse((responses = []) => {
              return this.confirmUnit(unitToAdd)
            })
          )
        }
      }
    })
  }

  handleRemoveUnit = unit => {
    this.setState({
      showWithdrawalConfirmationModal: true,
      unitToBeWithdrawn: unit
    })
  }

  handleWithdrawCloseModal = () => {
    this.setState({
      showWithdrawalConfirmationModal: false,
      editing: false
    })
  }

  submitRemoveUnit = () => {
    this.setState({
      showWithdrawalConfirmationModal: false
    })

    this.enrolmentUpdating(true)

    const payload = {
      courseCode: getAttributeCourseStaticInfo('courseCode'),
      courseVersion: getAttributeCourseStaticInfo('versionNumber'),
      courseAttemptNumber: getAttributeCourseStaticInfo('attemptNumber'),
      unitCode: this.state.unitToBeWithdrawn.unitCode,
      unitVersion: this.state.unitToBeWithdrawn.unitVersion,
      unitAttemptNumber: this.state.unitToBeWithdrawn.unitAttemptNumber
    }

    removeUnit(payload)
      .then((response = []) => {
        if (this.props.isLastUnit) {
          this.setState({
            showLastUnitWithdrawMessage: true
          })
        } else {
          this.enrolmentUpdated()
        }
      })
      .catch(() => {
        alert('Unable to remove this unit.')
        this.enrolmentUpdated()
      })
  }

  showLOACourseProgress = () => {
    this.setState({
      showLastUnitWithdrawMessage: false,
      showWithdrawModal: true
    })
    this.enrolmentUpdated()
  }

  getConfirmRemoveUnitTextForWithdrawDates = () => {
    let today = new Date()
    today = new Date(today.toDateString())

    if (this.state.unitToBeWithdrawn && new Date(new Date(this.state.unitToBeWithdrawn.unitWithdrawalWithoutFail).toDateString()) < today) {
      return (
        <div>
          <p className={'p-with-margin'}>You are about to withdraw from the unit, if you have registered for your class, this will be cancelled.</p>
          <p className={'p-with-margin'}>By withdrawing from the unit, this unit may be unavailable if you change your mind.</p>
          <p className={'p-with-margin'}>
            As the last date to withdraw without academic penalty for this unit has passed, a fail grade will be recorded on your academic transcript and you will remain liable for fees.
          </p>
          <div>Do you want to Proceed?</div>
        </div>
      )
    } else if (this.state.unitToBeWithdrawn && new Date(new Date(this.state.unitToBeWithdrawn.teachingCensusDate).toDateString()) < today) {
      return (
        <div>
          <p className={'p-with-margin'}>You are about to withdraw from the unit, if you have registered for your class, this will be cancelled.</p>
          <p className={'p-with-margin'}> By withdrawing from the unit, this unit may be unavailable if you change your mind.</p>
          <p className={'p-with-margin'}>As the Teaching Census date for this unit has passed, if you withdraw from this unit you will remain liable for fees.</p>
          <div>Do you want to Proceed?</div>
        </div>
      )
    } else if (this.state.unitToBeWithdrawn && new Date(new Date(this.state.unitToBeWithdrawn.unitWithdrawalWithoutFail).toDateString()) < today) {
      return (
        <div>
          <p className={'p-with-margin'}>You are about to withdraw from the unit, if you have registered for your class, this will be cancelled.</p>
          <p className={'p-with-margin'}>By withdrawing from the unit, this unit may be unavailable if you change your mind.</p>
          <p className={'p-with-margin'}>
            {' '}
            Enrolments for this study period have passed. If you withdraw from this unit, there will not be another available unit to enrol in for this study period.
          </p>
          <p className={'p-with-margin'}>
            {' '}
            If you wish to change the location or delivery for this unit,{' '}
            <a href="https://www.vu.edu.au/contact-us" target="_blank">
              contact VUHQ
            </a>{' '}
            for assistance.
          </p>
          <p className={'p-with-margin'}>Do you want to Proceed?</p>
        </div>
      )
    } else {
      return (
        <div>
          <p className={'p-with-margin'}>You are about to withdraw from the unit, if you have registered for your class, this will be cancelled.</p>
          <p className={'p-with-margin'}> By withdrawing from the unit, this unit may be unavailable if you change your mind.</p>
          <p className={'p-with-margin'}>Do you want to Proceed?</p>
        </div>
      )
    }
  }

  renderWithdrawConfirmationModal = () => {
    return (
      <CustomModal
        className={'drop-date-confirmation-modal'}
        isOpen={this.state.showWithdrawalConfirmationModal}
        userCanClose={true}
        handleCloseModal={this.handleWithdrawCloseModal}
        title="Online withdraw"
      >
        <div className="question-group">
          <div className="form-items-group">{this.getConfirmRemoveUnitTextForWithdrawDates()}</div>
        </div>
        <div className="row">
          <div className="col-xs-6 col-md-6">
            <button className="btn btn-lg btn-primary" onClick={() => this.submitRemoveUnit()}>
              OK
            </button>
          </div>
          <div className="col-xs-6 col-md-6">
            <button className="btn btn-lg btn-primary" onClick={this.handleWithdrawCloseModal}>
              CANCEL
            </button>
          </div>
        </div>
      </CustomModal>
    )
  }

  isLoadingPrefillUnits = () => {
    return !this.props.loadingUnits
  }

  handleSubmissionError = errorMessage => {
    this.setState({
      submitting: false
    })
    alert(errorMessage)
  }

  handleChooseDeliveryUnit = unit => {
    this.props.handleChooseDeliveryUnit(unit)
    this.setState({
      showModal: false
    })
  }

  /**
   * @return {Array}
   */
  getSuggestedUnits = () => {
    return this.props.studyPackages.filter(unit => unit.unitAvailabilityYear === this.state.addUnitModalYear && unit.unitAvailabilityStudyPeriodCode === this.state.addUnitModalCalendarType)
  }

  /**
   * Dispatch error to the screen.
   * @param {*} errorText error message.
   */
  dispatchSuggestionError = (errorText) => {
    alert(errorText);
    this.handleCloseSuggestionModal()
  }

  /**
   * Dispatch error to the screen.
   * @param {*} errorText error message.
   */
    dispatchEnrolmentErrorModel = (enrolmentErrors = []) => {
      this.setState({
        openSuggestionUnitsModel: false,
        openEnrolmentErrorModel: true
      })
      this.props.dispatchEnrolmentErrorModel(enrolmentErrors, false, null)
    }

    /**
   * Handle closing of the suggestion modal.
   */
    handleCloseEnrolmentErrorModal = (enrolmentUpdating = false) => {
      this.setState({
        openEnrolmentErrorModel: false
      })

      this.enrolmentUpdating(enrolmentUpdating)
    }

  /**
   * Handle closing of the suggestion modal.
   */
  handleCloseSuggestionModal = (enrolmentUpdating = false) => {
    this.setState({
      openSuggestionUnitsModel: false
    })

    this.enrolmentUpdating(enrolmentUpdating)
  }

  getEnrolledUnits = () => {
    return this.props.enrolledUnits
  }

  /**
   * Get all the units with attempt students that Victoria University considers
   * to be "enrolled".
   *
   * @return {Array}
   */
  getActiveEnrolledUnits = (excludeFailed = false) => {
    return this.getEnrolledUnits().filter(unit => {
      if (excludeFailed) {
        return unit.unitStatus !== 'WD' && unit.unitStatus !== 'WDE' && unit.unitStatus !== 'FAIL' && unit.removed !== true
      } else {
        return unit.unitStatus !== 'WD' && unit.unitStatus !== 'WDE' && unit.removed !== true
      }
    })
  }

  getEnrolmentPayload = unit => ({
    courseCode: getAttributeCourseStaticInfo('courseCode'),
    courseVersion: getAttributeCourseStaticInfo('versionNumber'),
    courseAttemptNumber: getAttributeCourseStaticInfo('attemptNumber'),
    academicYear: this.props.enrolYear,
    parentSspNo: getCourseStudentStudyPackageNumber(),
    studentUnits: [unit]
  })

  handleAddSuggestion = unit => {
    if (this.state.defaultLocation !== Location.ZV && unit.unitAvailabilityLocationCode === Location.ZV) {
      const confirmed = window.confirm('This is an online unit. Are you sure you want to add this unit to your enrolment?')
      if (!confirmed) {
        return
      }
    } else

    this.handleCloseSuggestionModal(true)

    const testDoubleUp = willDoubleUpUnits(
      this.getActiveEnrolledUnits(),
      unit.unitAvailabilityStudyPeriodCode,
      unit.unitAvailabilityYear,
      getDualInsanceBlockModelCalendarTypes().indexOf(unit.unitAvailabilityStudyPeriodCode) > -1 ? 2 : 1
    )

    if (testDoubleUp) {
      let doubleUpText =
        getDualInsanceBlockModelCalendarTypes().indexOf(unit.unitAvailabilityYear) > -1
          ? 'Maximum two units can be enrolled in a 8 Weeks Teaching Block. ' + 'You will need remove the existing unit from the block first before attempting to enrol into this unit.'
          : 'Unable to enrol. You have already enrolled in a unit for ' + unit.unitAvailabilityYear + ' in ' +getCalendarTypeName(unit.unitAvailabilityStudyPeriodCode, this.props.studyPeriods) + '. For assistance, please contact VUHQ'

      this.dispatchSuggestionError(doubleUpText)
      this.enrolmentUpdating(false)
      return
    }

    if (alreadyEnrolledUnit(this.getActiveEnrolledUnits(true), unit)) {
      this.dispatchSuggestionError('Unable to enrol. You are already enrolled in this unit. For assistance, please contact VUHQ')
      this.enrolmentUpdating(false)
      return
    }

    const testOverlapUnits = willOverlapUnits(unit, this.getActiveEnrolledUnits())

    const twoBlocks = unit.unitCreditPoints / 12 === 2
    let blockText = !twoBlocks ? `${unit.unitCreditPoints / 12} blocks` : 'block'
    if (testOverlapUnits) {
      this.dispatchSuggestionError(
        `${unit.unitCode} is ${unit.unitCreditPoints} credit points and requires enrolment across ${unit.unitCreditPoints /
          12} consecutive blocks. Please remove any units currently enrolled in the following ${blockText} and try again.`
      )
      this.enrolmentUpdating(false)
      return
    }

    if (this.props.blockMode !== BlockType.FourWeekBlock && this.props.blockMode !== BlockType.EightWeekBlock) {
      if(willExceed48CreditPoints(this.getActiveEnrolledUnits(true), unit)) {
        this.dispatchSuggestionError(`Unable to enrol. You can only enrol in 48 Credit Points for ${unit.unitAvailabilityYear} ${getCalendarTypeName(unit.unitAvailabilityStudyPeriodCode, this.props.studyPeriods)}. For assistance, please contact VUHQ`)
        this.enrolmentUpdating(false)
        return
      }
    }

    updateEnrolment(this.getEnrolmentPayload(unit, this.state))
      .then((responses = []) => {
        this.enrolmentUpdated()
      })
      .catch(error => {
        this.dispatchEnrolmentErrorModel(error.response.data.unitErrors)
      })
  }

  render() {
    //All are redirected to unit search page now

    if (this.state.redirectToSearch && !this.state.addUnitCalloutModalOpen) {
      return (
        <Switch>
          <Route
            path={getConfiguration('baseUrl') + '/manage/units/'}
            render={() => (
              <Redirect
                to={{
                  pathname: getConfiguration('baseUrl') + '/manage/units/enrolments/add',
                  state: {
                    teachingPeriod: '',
                    canAddBeyondFirstYear: false,
                    advanceStandingCreditRemaining: 0,
                    strictPattern: this.props.strictPattern,
                    addModalYear: this.state.addUnitModalYear,
                    addModalStudyPeriod: this.state.addUnitModalCalendarType,
                    loadSearchUnits: this.props.loadSearchUnits,
                    enrolledUnits: this.props.enrolledUnits,
                    currentEnrolment: this.props.currentEnrolment
                  }
                }}
              />
            )}
          />
          <Route
            render={() => (
              <Redirect
                to={{
                  pathname: getConfiguration('baseUrl') + '/units/add',
                  state: {
                    teachingPeriod: '',
                    canAddBeyondFirstYear: false,
                    advanceStandingCreditRemaining: 0,
                    strictPattern: this.props.strictPattern,
                    addModalYear: this.state.addUnitModalYear,
                    addModalStudyPeriod: this.state.addUnitModalCalendarType,
                    loadSearchUnits: this.props.loadSearchUnits,
                    enrolledUnits: this.props.enrolledUnits,
                    currentEnrolment: this.props.currentEnrolment
                  }
                }}
              />
            )}
          />
        </Switch>
      )
    } else if (this.state.redirectToSearch && this.state.addUnitCalloutModalOpen) {
      return (
        <Switch>
          <Route
            path={getConfiguration('baseUrl') + '/manage/units'}
            render={() => (
              <Redirect
                to={{
                  pathname: getConfiguration('baseUrl') + '/manage/units/enrolments/add',
                  state: {
                    enrollingForFirstTime: this.props.enrollingForFirstTime,
                    nonBfySearch: true,
                    addModalYear: this.state.addUnitModalYear,
                    addModalStudyPeriod: '',
                    loadSearchUnits: this.props.loadSearchUnits,
                    enrolledUnits: this.props.enrolledUnits,
                    currentEnrolment: this.props.currentEnrolment
                  }
                }}
              />
            )}
          />
          <Route
            render={() => (
              <Redirect
                to={{
                  pathname: getConfiguration('baseUrl') + '/units/add',
                  state: {
                    enrollingForFirstTime: this.props.enrollingForFirstTime,
                    nonBfySearch: true,
                    addModalYear: this.state.addUnitModalYear,
                    addModalStudyPeriod: '',
                    loadSearchUnits: this.props.loadSearchUnits,
                    enrolledUnits: this.props.enrolledUnits,
                    currentEnrolment: this.props.currentEnrolment
                  }
                }}
              />
            )}
          />
        </Switch>
      )
    }

    return (
      <section className="enrolment-container">
        {/*{!this.props.loadingUnits && this.getActiveEnrolledUnits().some(unit => unit.attemptStatus === 'COMPLETED') && (*/}
        {/*<div className="row">*/}
        {/*<div className="col-xs-12 col-md-offset-6 col-md-6">*/}
        {/*<div className="legend-container mobile-margin">*/}
        {/*<div className="legend-item"><span className="key key-complete"/> <span*/}
        {/*className="key-txt">Complete</span></div>*/}
        {/*<div className="legend-item"><span className="key key-not-complete"/> <span className="key-txt">Not Complete</span>*/}
        {/*</div>*/}
        {/*</div>*/}
        {/*</div>*/}
        {/*</div>*/}
        {/*)}*/}

        <UnitTable
          loading={this.props.loadingUnits || this.props.loadingEnrolmentGuide}
          blockStatus={this.props.blockStatus}
          blockMode={this.props.blockMode}
          units={this.props.enrolledUnits}
          currentEnrolment={this.props.currentEnrolment}
          onAdd={this.handleAddUnit}
          onEdit={this.handleEditUnit}
          onWithdraw={this.handleRemoveUnit}
          changeUnitUndoState={this.props.changeUnitUndoState}
          //changed this to send pattern map so that its decided at last what needs to be applied and also academic Year to know which pattern is applied
          blockModelStudentPatternApplied={this.props.blockModelStudentPatternApplied}
          firstPass={this.props.firstPass}
          enrolYear={this.props.enrolYear}
          handleAddUnitCallout={this.handleAddUnitCallout}
          strictPattern={this.props.strictPattern}
          studyPackages={this.props.studyPackages}
        />
        <EditUnitModal
          handleCloseModal={this.handleCloseModal}
          handleSubmitUnit={this.handleChooseDeliveryUnit}
          handleError={this.dispatchError}
          isOpen={this.state.showModal}
          unitCode={this.state.modalUnit}
          unitAvailabilityStudyPeriodCode={this.state.modalStudyPeriod}
          unitAvailabilityYear={this.state.modalAvailabilityYear}
          submitting={this.state.editing}
          enrolledUnits={this.props.currentEnrolment.filter(
            unit => unit.unitAvailabilityStudyPeriodCode === this.state.modalStudyPeriod && unit.unitAvailabilityYear === this.state.modalAvailabilityYear
          )}
          defaultLocation={this.props.defaultLocation}
        />

        <SuggestedUnitsModal
          handleCloseModal={() => this.setState({ openSuggestionUnitsModel: false })}
          isOpen={this.state.openSuggestionUnitsModel}
          studyPackages={this.props.studyPackages}
          calendarType={this.state.addUnitModalCalendarType}
          year={this.state.addUnitModalYear}
          enrolledUnits={this.props.enrolledUnits}
          units={this.getSuggestedUnits()}
          onAdd={this.handleAddSuggestion}
          cohorts={this.props.addOrDropCohorts}
          canAddBeyondFirstYear={this.props.canAddBeyondFirstYear}
          totalAdvanceStandingCredit={this.props.totalAdvanceStandingCredit}
          canAddUnits={this.props.canAddUnits}
          fycBlockModelStudent={this.props.fycBlockModelStudent}
          blockStatus={this.props.blockStatus}
          handleError={this.dispatchSuggestionError}
          coursePatternsNoExclusions={[]}
        />

        <CustomModal className={'drop-date-confirmation-modal'} isOpen={this.state.showLastUnitWithdrawMessage} userCanClose={false} title="Last unit withdrawal">
          <div className="question-group">
            <div className="form-items-group">Currently you have no active enrolment for this year, do you want to add a new unit?</div>
          </div>
          <div className="row">
            <div className="col-xs-6 col-md-6">
              <button className="btn btn-lg btn-primary" onClick={this.enrolmentUpdated}>
                Yes
              </button>
            </div>
            <div className="col-xs-6 col-md-6">
              <button className="btn btn-lg btn-primary" onClick={this.showLOACourseProgress}>
                No
              </button>
            </div>
          </div>
        </CustomModal>
        <DrupalModal className="modal-lg" isOpen={this.state.showWithdrawModal} slug="no-enrolment-modal" handleCloseModal={this.handleNoEnrolmentModal} userCanClose={true} />
        {this.renderWithdrawConfirmationModal()}
        <div className="enrolment-container__footer">
          {/*{this.props.commencing && (*/}
          {/*<div className="info-link">*/}
          {/*<p><ActionInfo className="btn-point-events"/> <button className="btn-link course-plan-btn" onClick={() => this.setState({showAdvancedStandingModal: true})}>Advanced Standing</button></p>*/}
          {/*</div>*/}
          {/*)}*/}

          {this.props.blockModelStudentPatternApplied && (
            <Route
              path={getConfiguration('baseUrl') + '/units'}
              exact={true}
              render={() => {
                return (
                  <p className="enrolment-container__footer-cta">
                    Once you are happy with your enrolment, click '<b>Submit enrolment</b>' to lock in your units.
                  </p>
                )
              }}
            />
          )}
        </div>
      </section>
    )
  }
}

export default EnrolmentContainer

